import { render, staticRenderFns } from "./FormCurrency.vue?vue&type=template&id=beb396c0&scoped=true&"
import script from "./FormCurrency.vue?vue&type=script&lang=js&"
export * from "./FormCurrency.vue?vue&type=script&lang=js&"
import style0 from "./FormCurrency.vue?vue&type=style&index=0&id=beb396c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb396c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb396c0')) {
      api.createRecord('beb396c0', component.options)
    } else {
      api.reload('beb396c0', component.options)
    }
    module.hot.accept("./FormCurrency.vue?vue&type=template&id=beb396c0&scoped=true&", function () {
      api.rerender('beb396c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormCurrency.vue"
export default component.exports